import dayjs from 'dayjs'
import Vue from 'vue'

Vue.filter('pretty_duration', (rawDuration, rawFormat = 'milliseconds') => {
  let duration = rawDuration
  if (rawFormat === 'seconds') { duration *= 1000 }

  const format = (duration / 3600000) > 1 ? 'HH:mm:ss' : 'm:ss'
  return dayjs.duration(duration).format(format)
})
